import styled from 'styled-components';

export const StyledMyAuditViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 88px;
  margin-bottom: 88px;
`;

export const ButtonBlockWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const TabsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const ScoreContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const MyAuditViewCommentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const TaggedUsersContainer = styled.div``;
